import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import type { IContractRequirementItem, IScheduleSummary } from '@/store/types';

import { RequirementType } from '@/store/enums';
import { getSchedulesTranslationSuffix, parseSchedulesToString } from '@/helpers';
import { media } from '@/styles/theme';

interface IProps {
  requirement: IContractRequirementItem;
  contractSchedules: IScheduleSummary[] | null;
}

const RequirementText = ({ requirement, contractSchedules }: IProps): React.ReactElement => {
  const { t } = useTranslation();
  switch (requirement.requirementType) {
    case RequirementType.base:
    case RequirementType.peak:
      return (
        <Text>
          <TextLabel>
            {t(`client.gigs.gigRequirements.periods.${getSchedulesTranslationSuffix(requirement, contractSchedules)}`, {
              hours: requirement.weeklyBlocks / 2,
              schedules: parseSchedulesToString(requirement),
            })}
          </TextLabel>
          {requirement.workSchedules.map((item, index) => (
            <Timeframe key={index}>
              <span className="day">{item.weekday}</span>
              <span>{item.hours}</span>
            </Timeframe>
          ))}
        </Text>
      );
    case RequirementType.max:
    case RequirementType.min:
      return (
        <ListText>
          {t(
            `client.gigs.gigRequirements.${requirement.requirementType}.${getSchedulesTranslationSuffix(
              requirement,
              contractSchedules,
            )}`,
            {
              hours: requirement.weeklyBlocks / 2,
              schedules: parseSchedulesToString(requirement),
            },
          )}
        </ListText>
      );
    default:
      return <></>;
  }
};

export { RequirementText };

const Text = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #4b5563;
`;

const ListText = styled(Text)`
  line-height: 18px;
`;

const TextLabel = styled.div`
  margin-bottom: 0.25rem;
`;

const Timeframe = styled.div`
  display: flex;

  .day {
    width: 25%;

    ${media.laptop} {
      width: 15%;
    }
  }
`;
